import { render } from "./fsActivitySignInfo.vue?vue&type=template&id=04befd84&scoped=true"
import script from "./fsActivitySignInfo.vue?vue&type=script&lang=js"
export * from "./fsActivitySignInfo.vue?vue&type=script&lang=js"

import "./fsActivitySignInfo.vue?vue&type=style&index=0&id=04befd84&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04befd84"]])

export default __exports__